import { ReportsMetadata, ReportRecord } from '../models/report';

type ReportsCache = {
  orgId: string | null;
  metadata: ReportsMetadata | null;
  reports: ReportRecord[] | null;
};

const cache: ReportsCache = {
  orgId: null,
  metadata: null,
  reports: null,
};

export const getReportsCache = (orgId: string | null) => {
  if (!orgId || cache.orgId !== orgId) return { metadata: null, reports: null };
  return { metadata: cache.metadata, reports: cache.reports };
};

export const setReportsCache = (orgId: string, updates: Partial<ReportsCache>) => {
  if (cache.orgId !== orgId) {
    cache.orgId = orgId;
    cache.metadata = null;
    cache.reports = null;
  }
  if (updates.metadata !== undefined) cache.metadata = updates.metadata;
  if (updates.reports !== undefined) cache.reports = updates.reports;
};

export const clearReportsCache = () => {
  cache.orgId = null;
  cache.metadata = null;
  cache.reports = null;
};
